// extracted by mini-css-extract-plugin
export var card = "_v5-0";